import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import {Router} from '@angular/router';
import {UserService} from './user.service';
import {KeycloakService} from 'keycloak-angular';
import {OAuthService} from './o-auth.service';
import {CookieService} from 'ngx-cookie-service';
import {ConfigService} from './config.service';
import {NgxPermissionsService} from 'ngx-permissions';

@Injectable({
    providedIn: 'root'
})
export class InitializerService {

    constructor(private router: Router,
                private userService: UserService,
                private keycloak: KeycloakService,
                private oauthService: OAuthService,
                private cookieService: CookieService,
                private configService: ConfigService,
                private permissionsService: NgxPermissionsService) {
    }

    initKeycloak(): Promise<boolean> {
        return this.keycloak.init({
            config: {
                url: this.configService.keycloakUrl,
                realm: this.configService.realm,
                clientId: this.configService.clientId
            },
            initOptions: {
                onLoad: 'login-required',
                checkLoginIframe: false
            },
            bearerPrefix: 'Bearer',
            enableBearerInterceptor: true,
            bearerExcludedUrls: ['/assets', '/clients/public']
        });
    }

    initPermissions(): Promise<unknown> {
        return new Promise(async (resolve, reject) => {
            try {
                let permissions: string[];
                const loggedUser = await this.userService.getLoggedUser();

                if (this.cookieService.check(loggedUser.id)) {
                    permissions = this.cookieService.get(loggedUser.id).split(',');
                } else {
                    const roles = await this.oauthService.findAllRolesByUser(loggedUser.id).toPromise();
                    permissions = await Promise.all(roles
                        .map(r => this.oauthService.findPermissionsByRoleId(r.id).toPromise()))
                        .then(p => _.uniq(_.flattenDeep(p)));
                    this.cookieService.set(loggedUser.id, permissions.join(','));
                }

                this.permissionsService.addPermission(permissions);
                resolve();
            } catch (e) {
                reject(e);
            }
        });
    }

}